@if (type === 'application') {
  @if (user && userType === 'employee') {
    <header class="header header-application"
      [@smoothFadeEnter]
      >
      <div class="header-start">
        <a [routerLink]="['/']" class="header-logo">
          <img [ngSrc]="'/assets/images/logo.png'" priority="true" width="128" height="28" alt="" />
        </a>
      </div>

      @if (user.user_profile.company?.search_name) {
        <nav class="nav-desktop header-center">
          <ul class="header-menu">
            <li class="header-menu-item">
              <a [routerLink]="['/', companySearchName, 'dashboard']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="header-menu-link"
                >
                <span>{{ 'COMPANY.NAVBAR.DASHBOARD' | translate }}</span>
                @if ((notifications$ | async)?.applications) {
                  <span class="badge"
                    [@smoothFade]
                    >
                    {{ (notifications$ | async)?.applications }}
                  </span>
                }
              </a>
            </li>
            <li class="header-menu-item">
              <a [routerLink]="['/', companySearchName, 'alle-soknader']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="header-menu-link"
                >
                <span>{{ 'COMPANY.NAVBAR.ALL_APPLICANTS' | translate }}</span>
              </a>
            </li>
            @if (webHelper.isHasWriteAccess(user)) {
              <li
                class="header-menu-item">
                <a [routerLink]="['/' + companySearchName + '/meldinger']"
                  routerLinkActive="active"
                  class="header-menu-link"
                  >
                  <span>{{ 'COMPANY.NAVBAR.NOTIFICATIONS' | translate }}</span>
                  @if ((notifications$ | async)?.messages) {
                    <span class="badge"
                      [@smoothFade]
                      >
                      {{ (notifications$ | async)?.messages }}
                    </span>
                  }
                </a>
              </li>
            }
          </ul>
        </nav>
        <div class="menu-personal menu-personal-desktop header-end">
          @if (getUserRole(user) === USER_ROLE.ADMIN ||
            getUserRole(user) === USER_ROLE.DEPARTMENT_ADMIN ||
            getUserRole(user) === USER_ROLE.RECRUITER) {
            <app-button
          [config]="{
                view: 'primary',
                label: 'COMPANY.NAVBAR.CREATE_JOB',
              }"
              (click)="router.navigate(['/', companySearchName, 'opprett-stilling']);"
            ></app-button>
          }
          <app-menu>
            <div class="menu-trigger" menu-trigger>
              <app-profile-image
              [config]="{
                    menu: true,
                    image: user?.user_profile?.company?.logos_settings?.dark_logo?.datafile || user?.user_profile?.company?.logo?.datafile,
                    size: 40,
                    borderWidth: 1,
                  }"
              ></app-profile-image>
            </div>
            @if (user.user_profile.companies?.length > 1) {
              <div class="menu-item menu-item-info">
                <div class="user-name">
                  {{ user.user_profile.company?.name }}
                </div>
              </div>
            }
            <a [routerLink]="['/', companySearchName]"
              class="menu-item-wrapper">
              <app-dropdown-item class="menu-item">
                <span class="menu-link">
                  <app-icon class="menu-icon" iconName="careerPage"></app-icon>
                  <span>{{ 'COMPANY.NAVBAR.COMPANY_PROFILE' | translate }}</span>
                </span>
              </app-dropdown-item>
            </a>
            <app-dropdown-item class="menu-item"
              [hasSubmenu]="true"
              [positions]="nestedPositions"
              >
              <span class="menu-link">
                <app-icon class="menu-icon" iconName="language"></app-icon>
                <span>{{ 'COMMON.CHANGE_LANGUAGE' | translate }}</span>
              </span>
              <div submenu-content>
                @for (lang of languages; track lang) {
                  <app-dropdown-item
                    [active]="lang.code === activeLanguage"
                    (click)="selectLanguage(lang)">
                    <div>{{ lang.name }}</div>
                  </app-dropdown-item>
                }
              </div>
            </app-dropdown-item>
            <a [routerLink]="['/' + companySearchName + '/settings/personal']" class="menu-item-wrapper">
              <app-dropdown-item class="menu-item">
                <span class="menu-link">
                  <app-icon class="menu-icon" iconName="settings"></app-icon>
                  <span>{{ 'COMPANY.NAVBAR.SETTINGS' | translate }}</span>
                </span>
              </app-dropdown-item>
            </a>
            @if (user?.user_profile?.companies?.length >= 2) {
              <a [routerLink]="['/', 'company-select']"
                class="menu-item-wrapper">
                <app-dropdown-item class="menu-item">
                  <span class="menu-link">
                    <app-icon class="menu-icon" iconName="company"></app-icon>
                    <span>{{ 'COMPANY.NAVBAR.COMPANY_SELECT' | translate }}</span>
                  </span>
                </app-dropdown-item>
              </a>
            }
            <a [routerLink]="['/' + companySearchName + '/support']" class="menu-item-wrapper">
              <app-dropdown-item class="menu-item">
                <span class="menu-link">
                  <app-icon class="menu-icon" iconName="support">contact_support</app-icon>
                  <span>{{ 'COMPANY.NAVBAR.SUPPORT' | translate }}</span>
                </span>
              </app-dropdown-item>
            </a>
            <app-dropdown-item class="menu-item menu-logout"
              (click)="webHelper.logout()">
              <span>{{ 'COMMON.LOGOUT' | translate }}</span>
            </app-dropdown-item>
          </app-menu>
        </div>
      }

      @if (!user.user_profile.company?.search_name) {
        <div class="nav-short header-end">
          <nav class="nav-desktop">
            <ul class="header-menu">
              <li class="header-menu-item">
                <a (click)="webHelper.logout()" class="header-menu-link">{{ 'COMMON.LOGOUT' | translate }}</a>
              </li>
            </ul>
          </nav>
          <app-language-choiser class="language-picker" mode="short"></app-language-choiser>
        </div>
      }
      <app-button
        class="burger"
        [config]="{
          view: 'icon',
          icon: {
            name: 'burgerMenu'
          },
        }"
        (click)="showMobileMenu()"
      ></app-button>
    </header>
  }

  @if (user && userType === 'applicant') {
    <header class="header header-application">
      <div class="header-start">
        <a [routerLink]="['/']" class="header-logo">
          <img ngSrc="/assets/images/logo.png" priority="true" width="128" height="28" alt="" />
        </a>
      </div>
      <ng-container *ngTemplateOutlet="navUserList"></ng-container>
      <app-button
        class="burger header-end"
      [config]="{
          view: 'icon',
          icon: {
            name: 'burgerMenu'
          },
        }"
        (click)="showMobileMenu()"
      ></app-button>
    </header>
  }

  @if (!user && noAuth === false) {
    <header class="header header-application header-justify">
      <a [routerLink]="['/']" class="header-logo">
        <img ngSrc="/assets/images/logo.png" priority="true" width="128" height="28" alt="" />
      </a>
      <app-language-choiser class="language-picker" mode="short"></app-language-choiser>
      <app-button
        class="burger"
      [config]="{
          view: 'icon',
          icon: {
            name: 'burgerMenu'
          },
        }"
        (click)="showMobileMenu()"
      ></app-button>
    </header>
  }
}

@if (type === 'website') {
  <header class="header header-website"
    [class.header-opened]="isIndustriesMenuOpen"
    >
    <div class="website-container">
      <div class="header-website-wrapper">
        <div class="header-start">
          <a [routerLink]="['/']" class="header-logo">
            <img ngSrc="/assets/images/logo.png" priority="true" width="128" height="28" alt="" />
          </a>
        </div>

        @if (!isMobile) {
          <ng-container *ngTemplateOutlet="navWebsite"></ng-container>
        }

        @if (!isMobile) {
          <app-language-choiser
            class="language-picker"
            mode="short"
            [langList]="languages"
          ></app-language-choiser>
        }

        @if (!isMobile) {
          <app-button
            class="login-button"
            [config]="{
              view: 'outlined',
              label: 'COMMON.LOGIN' | translate
            }"
            [routerLink]="['/login']">
          </app-button>

          <app-button
            [config]="{
              view: 'primary',
              icon: {
                name: 'specialArrowRight',
                position: 'suffix'
              },
              label: 'COMMON.BOOK_A_DEMO' | translate
            }"
            [routerLink]="['/book-a-demo']"
          ></app-button>
        }

        <div class="header-website-nd-buttons">
          @if (isMobile) {
            <app-button
              class="book-demo-btn"
              [config]="{
                view: 'primary',
                icon: {
                  name: 'specialArrowRight',
                  position: 'suffix'
                },
                label: 'COMMON.BOOK_A_DEMO' | translate
              }"
              [routerLink]="['/book-a-demo']">
            </app-button>
          }

          <app-button
            class="burger"
            [config]="{
              view: 'icon',
              icon: {
                name: 'burgerMenu'
              },
            }"
            (click)="showMobileMenu('website')"
          ></app-button>
        </div>
      </div>
    </div>
  </header>

  @if (isIndustriesMenuOpen) {
    <app-industries-menu class="industries-menu-wrapper"
      [(isOpen)]="isIndustriesMenuOpen"
      [@smoothCollapse]
      >
    </app-industries-menu>
  }
}

<ng-template #navUserList>
  <nav class="nav-desktop header-center">
    <ul class="header-menu">
      <li class="header-menu-item">
        <a [routerLink]="['/bruker']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="header-menu-link"
          >
          <span>{{ 'USER.MENU.DASHBOARD' | translate }}</span>
        </a>
      </li>

      <li class="header-menu-item">
        <a [routerLink]="['/bruker/video-cv-er']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="header-menu-link"
          >
          <span>{{ 'USER.MENU.VIDEO_CV' | translate }}</span>
        </a>
      </li>

      <li class="header-menu-item">
        <a [routerLink]="['/bruker/meldinger']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="header-menu-link"
          >
          <span>{{ 'USER.MENU.NOTIFICATIONS' | translate }}</span>
        </a>

        @if ((notifications$ | async)?.messages) {
          <span class="badge"
            [@smoothFade]
            >
            {{ (notifications$ | async)?.messages }}
          </span>
        }
      </li>
    </ul>
  </nav>

  <div class="menu-personal menu-personal-desktop header-end">
    <app-menu>
      <div class="menu-trigger" menu-trigger>
        <app-profile-image
          [config]="{
                  placeholder: user.first_name?.[0] + user.last_name?.[1],
                  image: user.user_profile?.profile_picture?.datafile || 'assets/images/smile.svg',
                  size: 40,
                  borderWidth: 1,
                }"
        ></app-profile-image>
      </div>

      <div class="menu-item menu-item-info">
        <div class="user-name">{{user.first_name + ' ' + user.last_name}}</div>

        <div class="user-email">{{user.email}}</div>
      </div>

      <app-dropdown-item class="menu-item"
        [hasSubmenu]="true"
        [positions]="nestedPositions"
        >
        <span class="menu-link">
          <app-icon class="menu-icon" iconName="language"></app-icon>

          <span>{{ 'COMMON.CHANGE_LANGUAGE' | translate }}</span>
        </span>

        <div submenu-content>
          @for (lang of languages; track lang) {
            <app-dropdown-item
              [active]="lang.code === activeLanguage"
              (click)="selectLanguage(lang)">
              <div>{{ lang.name }}</div>
            </app-dropdown-item>
          }
        </div>
      </app-dropdown-item>

      <a [routerLink]="['/bruker/endre-profil']" class="menu-item-wrapper">
        <app-dropdown-item class="menu-item">
          <span class="menu-link">
            <app-icon class="menu-icon" iconName="person"></app-icon>

            <span>{{ 'USER.MENU.EDIT_PROFILE' | translate }}</span>
          </span>
        </app-dropdown-item>
      </a>

      <a [routerLink]="['/kontakt']" class="menu-item-wrapper">
        <app-dropdown-item class="menu-item">
          <span class="menu-link">
            <app-icon class="menu-icon" iconName="support"></app-icon>

            <span>{{ 'COMPONENTS.MENU.CONTACTS' | translate }}</span>
          </span>
        </app-dropdown-item>
      </a>

      <app-dropdown-item class="menu-item menu-logout"
        (click)="webHelper.logout()">
        <span>{{ 'COMMON.LOGOUT' | translate }}</span>
      </app-dropdown-item>
    </app-menu>
  </div>
</ng-template>

<ng-template #navWebsite>
  <nav class="nav-desktop header-center">
    <ul class="header-menu">
      <li class="header-menu-item">
        <a [routerLink]="['/price']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="header-menu-link"
          >
          <span>{{ 'COMMON.PRICE' | translate }}</span>
        </a>
      </li>

      @if (!isMobile) {
        <li class="header-menu-link industries-trigger"
          (click)="toggleIndustriesMenu()"
          >
          <span>{{ 'SOLUTIONS.TITLE' | translate }}</span>

          <app-icon class="industries-trigger-icon"
            [iconName]="isIndustriesMenuOpen ? 'specialArrowUp' : 'specialArrowDown'">
          </app-icon>
        </li>
      } @else {
        <app-industries-menu></app-industries-menu>
      }

      <li class="header-menu-item">
        <a [routerLink]="['/funksjonaliteter']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="header-menu-link"
          >
          <span>{{ 'FUNCTIONALITY.LABEL' | translate }}</span>
        </a>
      </li>

      <li class="header-menu-item">
        <a [routerLink]="['/contact']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="header-menu-link"
          >
          <span>{{ 'COMMON.CONTACT' | translate }}</span>
        </a>
      </li>

    </ul>
  </nav>
</ng-template>

